import {
    Card,
    CardContent,
    Grid,
    Skeleton,
    Stack,
    Typography
} from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import RateReviewIcon from '@mui/icons-material/RateReview';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const cards = [
    {
        key: 'pending',
        label: 'Pendientes por reseñar',
        color: 'warning.main',
        Icon: CreateIcon
    },
    {
        key: 'published',
        label: 'Reseñas publicadas',
        color: 'success.main',
        Icon: RateReviewIcon
    },
    {
        key: 'hidden',
        label: 'Reseñas ocultas',
        color: 'text.secondary',
        Icon: VisibilityOffIcon
    }
];

const ReviewSummaryCards = ({ available, loading, summary }) => (
    <Grid container spacing={2} sx={{ my: 2 }}>
        {cards.map(({ key, label, color, Icon }) =>
            <Grid item xs={12} sm={4} key={key}>
                <Card variant="outlined" sx={{ height: '100%' }}>
                    <CardContent>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Icon sx={{ color, fontSize: 34 }} />
                            <div>
                                {loading ?
                                    <Skeleton width={45} height={36} />
                                :
                                    <Typography variant="h5" fontWeight="bold">
                                        {available ? summary[key] || 0 : '—'}
                                    </Typography>
                                }
                                <Typography variant="body2" color="text.secondary">
                                    {label}
                                </Typography>
                            </div>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>
        )}
    </Grid>
);

export default ReviewSummaryCards;
